
/* eslint-disable */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */

import { Component, Input, OnInit, EventEmitter, Output, ViewEncapsulation, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { GlobalSearchFiltersService } from './../../services/global-search-filters.service';
import { tap, switchMap, debounceTime } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { SearchResultModal, tabValues, SearchDataModel, SearchRequesModel, SearchHistoryModal, chipInfo, SearchHistoryResultsModal, ContextPointInfo, SelectedSearchResult, ActiveData, userContextAcessInfo } from '../../contracts/modal';
import { DividerOption } from '../../../divider/divider.model';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { regionsContextPointSubTypeId, SalesRegionsContextPointSubTypeId } from '../../enums/search.enums';

@Component({
    selector: 'nalco-search-bar-and-result',
    templateUrl: './search-bar-and-result.component.html',
    styleUrls: ['./search-bar-and-result.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SearchBarAndResultComponent implements OnInit, OnDestroy {

  @Input() tabValue: tabValues;

  @Input() searchData: SearchDataModel;
  @Input() enableMulitpleSelection: boolean
  @Output() selectedResult?: EventEmitter<SelectedSearchResult> = new EventEmitter();
  @Output() selectedResultInHierarchy?: EventEmitter<any> = new EventEmitter();
  @Output() multipleSelectedResult?: EventEmitter<SearchResultModal[]> = new EventEmitter();

  private instanceId = 'Search Component';
  private subscriptions: Subscription[] = [];

  searchInput = '';
  showErrorMessage = false;
  searchHistory: SearchHistoryResultsModal[] = [];
  selectedChips: chipInfo[];
  searchResults: SearchResultModal[];
  isloading = false;
  txtQueryChanged: Subject<string> = new Subject<string>();
  resultInfo = '';
  dividerCss: DividerOption = {
    color: "#bac7d8",
    minLength: '100%',
    isHorizontal: true
  }
  searchRequest: SearchRequesModel;
  saveHistory: SearchHistoryModal;
  filterId: number;
  currentIndex = 0;
  initiateManualSearch = false;
  placeHolder: string;
  selectedItem;
  regionCountriesData: ContextPointInfo[];
  salesRegionDistrictsTerritoriesData: ContextPointInfo[];
  hierarchyData: ContextPointInfo[]
  selectedSubGroupAccount: string;
  selectedInfo: SearchHistoryModal | userContextAcessInfo;
  selectedMultipleItems: any[] = [];
  pendingMultiSelection: SearchResultModal[] = []; // Store pending selections before "Next" button
  showNextButton = false; // Control Next button visibility
  nextButtonDisabled = false; // Control Next button disabled state
  currentLevelHasChildren = false; // Check if current level has children
  pendingSelectionCriteria: { selectionHierarchy: any[], activeGroupIds: number[] } | null = null; // Store selection criteria for later application
  isMultiSelectionActivated = false;
  disableMultiSelectButtons = false;
  isUpdateSubGroupActivated = false;

  constructor(private globalSearchFiltersService: GlobalSearchFiltersService,
    private translate: TranslateService,
    private activeModal: NgbActiveModal,private cdr: ChangeDetectorRef) {


  }


  ngOnInit(): void {
    this.subscriptions.push(
      this.txtQueryChanged.pipe(
        debounceTime(300),
        tap(),
        switchMap(async () => {
          if (this.searchInput && !this.initiateManualSearch) {
            this.getContextSearchResult();
          }
        })
      ).subscribe(),
      this.globalSearchFiltersService.getEnableToggleDivision().subscribe(value => {
        if (!value) {
          this.setInitialData();
        }
      }));
    this.getSearchHistory();
    this.selectedChips = [];
    this.placeHolder = this.tabValue.placeholder;
    if (this.tabValue?.subGroups?.enableMultipleSelection) {
      this.enableMulitpleSelection = true
    }
  }


  /**
   * @description This function is used to get the text change subject get triggered
   */

  onSearchSite(): void {
    this.resultInfo = ""
    this.showErrorMessage = false;
    setTimeout(() => {
      if (this.searchInput) {
        this.txtQueryChanged.next(this.searchInput);
        this.cdr.markForCheck();
      }
    }, 0);
  }



  /**
   * @description Retrieves the search history or relevant data based on the current tab selection
   * This method performs the following actions:
   * - Resets the error message state.
   * - Fetches recent search history if the current tab allows showing recent searches.
   * - Retrieves user context access if the current tab allows showing default or favorite data.
   * - Fetches geographical region data if the current tab is "Geo Region".
   * - Fetches sales region data if the current tab is "Sales Region".
   * 
   * @returns {void} This method does not return a value.
   */

  getSearchHistory(): void {
    this.showErrorMessage = false;
    if (this.tabValue.showRecents) {
      this.fetchSearchHistory();
    }
    if ((this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT') || this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.SITES')) && (this.tabValue.showDefaultData || this.tabValue.showFavouriteData)) {
      this.initiateAccessApis();
    }
    if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.GEOGRAPHY_REGION')) {
      this.getGeoRegions();
    }
    if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.SALES_REGION')) {
      this.getEVOCHierarchy();
    }
  }


  /**
   * Initiates the appropriate API calls based on the current tab value.
   * If the current tab is for Corporate Account, fetches user context access data.
   * Otherwise, retrieves sites and favorites data.
   */
  initiateAccessApis(): void {
  if(this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT')){
    this.getUserContextAccess();
  }else {
    this.getSitesAndFavorites();
  }
  }

  /**
   * Retrieves sites data and organizes it into default and favorites collections.
   * 
   * This method fetches sites from the global search filters service, processes the response
   * to add primary text concatenation and site name mapping, then filters the data into
   * default and favorites arrays based on the current tab configuration.
   * 
   * @remarks
   * - Sets loading state to true at start and false on completion/error
   * - Adds subscription to the subscriptions array for cleanup
   * - On success: processes response data and populates tabValue.defaultData and tabValue.favouritesData
   * - On error: clears data arrays and shows error message
   * - Respects tabValue.showDefaultData and tabValue.showFavouriteData flags for conditional data loading
   * - Uses concatPrimaryText without objProp to leverage existing conditional logic for Sites
   */
  getSitesAndFavorites(){
    this.isloading = true;
    this.subscriptions.push(
      this.globalSearchFiltersService.getSites().subscribe({
        next: (response: ContextPointInfo[]) => {
          if (response?.length > 0) {
            response = this.concatPrimaryText(response, 'name').map(item => ({
              ...item,
              primaryText: item.friendlyName ?? item.siteNameEnglish ?? item.name ?? '',
              name: item.friendlyName ?? item.siteNameEnglish ?? item.name ?? ''
            }));
            this.tabValue.defaultData = this.tabValue.showDefaultData ? this.filterFavourites(response, false) : [];
            this.tabValue.favouritesData = this.tabValue.showFavouriteData ? this.filterFavourites(response, true) : [];
          } else {
            this.tabValue.defaultData = [];
            this.tabValue.favouritesData = [];
          }
          this.isloading = false;
        },
        error: () => {
          this.showErrorMessage = true;
          this.tabValue.defaultData = [];
          this.tabValue.favouritesData = [];
          this.isloading = false;
        }, complete: () => {
          this.cdr.markForCheck();
        }
      })
    );
  }

  /**
   * @description Fetches the search history for the current user based on the selected tab value.
   * This method retrieves the user's search history from the `globalSearchFiltersService`
   * and processes the data to map it with search and filter naming conventions.
   * 
   * - If the tab value corresponds to 'Corporate Account' and customer division selection
   *   is disabled, a specific context type ID is used.
   * - The search history is transformed to include additional properties such as
   *   `primaryText`, `secondaryText`, and filter-specific keys.
   * - The processed search history is then mapped with additional search data.
   * 
   * Handles loading state and error scenarios:
   * - Sets `isloading` to `true` while the data is being fetched.
   * - On success, updates the `searchHistory` and processes it further.
   * - On error, displays an error message and clears recent data.
   * 
   * @returns {void}
   */
  fetchSearchHistory(): void {
    if (this.tabValue?.recentsData?.length > 0) {
      this.isloading = false;
      this.mapWithSearchData(this.mapWithFilterNaming(this.tabValue.recentsData));
    } else {
      this.isloading = true;
      const contextTypeId = (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT')) ? 1 : null;
      this.subscriptions.push(
        this.globalSearchFiltersService.getUserContextSearchHistory(this.tabValue.contextPointTypeId, contextTypeId).subscribe({
          next: (data) => {
            this.isloading = false;
            this.searchHistory = data?.map(element => ({
              ...element,
              primaryText: element.contextPointName,
              secondaryText: this.createSecondaryTextOnNames(element),
              filterType: this.translate.instant(this.tabValue.name),
              [this.tabValue.contextPointIdKeys[0]]: element.contextPointId,
              [this.tabValue.contextPointIdKeys[1]]: element.contextPointName,
            }));
            this.mapWithSearchData(this.mapWithFilterNaming(this.searchHistory));
          },
          error: () => {
            this.showErrorMessage = true;
            this.tabValue.recentsData = [];
            this.isloading = false;
          }, complete: () => {
            this.isloading = false;
            this.cdr.markForCheck();
          }
        })
      );
    }
  }


  /**
   * @description removes duplicates.
   * Adds a `recentsData` property to objects in `SearchTabs` containing the matching object from `searchHistoryData`.
   * @param {SearchHistoryResultsModal[]} searchHistoryData - The array of objects to search from.
   */

  mapWithSearchData(searchHistoryData: SearchHistoryResultsModal[]) {
    const removedDuplicates = searchHistoryData?.filter(
      (propertyValues, index) => index === searchHistoryData.findIndex(
        other => propertyValues.contextPointId === other.contextPointId
      ));
    this.tabValue.recentsData = removedDuplicates
  }


  /**
   * @description Fetches search results based on the provided input and filters.
   * Handles loading state, result processing, and error handling.
   *
   * @returns {void}
   */

  getContextSearchResult(searchBody?: SearchRequesModel): void {
    this.setInitialData();
    this.isloading = true;
    this.cdr.markForCheck();
    this.searchRequest = {
      searchText: this.searchInput.toString(),
      count: this.tabValue.maxSearchCount ? this.tabValue.maxSearchCount : 100,
      searchInFields: this.tabValue.searchFields,
      responseFields: this.tabValue.responseFileds
    }
    this.subscriptions.push(
      this.globalSearchFiltersService.getSearchResult(searchBody ? searchBody : this.searchRequest, this.instanceId, 700000).subscribe(
        {
          next: (results) => {
            if (results?.data) {
              if (searchBody) {
                if (results?.data?.searchResults?.length > 0) {
                  const finalData = { ...results.data.searchResults[0], ...this.selectedInfo };
                  finalData.isFavorite ? this.selectSearchedInput(finalData) : this.checkHierarchy(finalData);
                }
              } else {
                results.data.searchResults = this.checkAndMapAccountsObject(results.data.searchResults);
                if (this.tabValue?.hierarchyValues?.length > 0 && this.tabValue.enableMultiLevelSearchInContext) {
                  this.tabValue.hierarchyValues.forEach((hierarchyValue, index) => {
                    const searchResults = this.concatPrimaryText(
                      results.data.searchResults,
                      hierarchyValue.value,
                      index
                    );
                    hierarchyValue.searchResults = this.removeDuplicates(searchResults, hierarchyValue.uniqueKey);
                  });
                } else {
                  const searchResults = this.concatPrimaryText(results.data.searchResults);
                  this.tabValue.searchResults = this.removeDuplicates(searchResults, this.tabValue.uniqueKey);
                }
              }

            } else {
              if (this.tabValue?.hierarchyValues?.length > 0 && this.tabValue.enableMultiLevelSearchInContext) {
                this.tabValue.hierarchyValues?.map(value => {
                  value.searchResults = []
                  return value
                })
              }
              this.tabValue.searchResults = [];
              this.resultInfo =
                `${this.translate.instant('ACTION_LOG.SEARCH.SEARCH_ERROR_INFO_FIRST_SENTENCE')}"${this.searchInput}"` +
                `${this.translate.instant('ACTION_LOG.SEARCH.SEARCH_ERROR_INFO_SECOND_SENTENCE')}`;
              this.cdr.markForCheck();
            }
            this.isloading = false;
            this.cdr.markForCheck();
          },
          error: (error) => {
            this.activeModal.close();
            this.showErrorMessage = true;
            this.tabValue.searchResults = [];
            this.isloading = false;
          }, complete: () => {
            this.cdr.markForCheck();
          }
        }
      )
    );
  }

  /**
  * Handles the click event for selecting subgroups.
  * Clears the hierarchy values, enables selection buttons,
  * and checks the hierarchy for the currently active data.
  */
  onSelectSubGroups(): void {
    this.tabValue.hierarchyValues = [];
    this.tabValue.enableSelectionButtons = true;
    this.selectedSubGroupAccount = this.tabValue.activeData.contextPointName;
    this.selectedItem = this.tabValue.activeData;
    this.selectedItem.primaryText = this.tabValue.activeData.contextPointName;
    this.checkHierarchy(this.tabValue?.activeData);
    if (this.enableMulitpleSelection && this.selectedChips?.length > 0) {
    const previousChip = this.selectedChips[this.selectedChips?.length - 1];
    const remainingDataItem = {
      contextPointId: previousChip.contextPointId,
      contextPointName: previousChip.contextPointName,
      selectionHierarchy: [],
      groupedIds: previousChip.groupedIds || [],
    };
      this.globalSearchFiltersService.setMultipleHierarchyData(this.concatPrimaryText([remainingDataItem], 'contextPointName'))
    }
    this.updateNextButtonVisibility();
    this.cdr.markForCheck();

  }


  /**
 * Updates the subgroups selection state based on the current active selection hierarchy.
 * - Rebuilds the chip list from the active selection hierarchy.
 * - Enables selection buttons and manual search mode.
 * - Sets the current index to the last item in the selection hierarchy.
 *
 * @remarks
 * This method is typically called when the user wants to edit or update their subgroup selections.
 * It ensures the UI reflects the current selection hierarchy and prepares the component for further selection.
 */
  updateSubGroups(): void {
    this.selectedSubGroupAccount = this.tabValue.activeData.contextPointName;
    this.hierarchyData = this.globalSearchFiltersService.getPreviousHierarchyData().subGroupData ? this.globalSearchFiltersService.getPreviousHierarchyData().subGroupData : this.hierarchyData;
    this.selectedItem = this.globalSearchFiltersService.getPreviousHierarchyData().selectedItem ? this.globalSearchFiltersService.getPreviousHierarchyData().selectedItem : this.selectedItem;
    let selectionHierarchy = this.globalSearchFiltersService.getMultiplePreviousHierarchyData()[0]?.selectionHierarchy ? this.globalSearchFiltersService.getMultiplePreviousHierarchyData()[0]?.selectionHierarchy : this.tabValue?.activeData?.selectionHierarchy;
    if (Array.isArray(selectionHierarchy) && selectionHierarchy?.length > 0) {
      selectionHierarchy.forEach(item => {
        this.selectedSubGroupAccount = item.sequenceNumber === 0 ? item.contextPointName : this.selectedSubGroupAccount;
        this.initiateChipList(item)
      });
      this.tabValue.enableSelectionButtons = true;
      this.initiateManualSearch = true;
      this.currentIndex = selectionHierarchy?.length - 1;
      if (this.enableMulitpleSelection) {
        this.isUpdateSubGroupActivated = true;
        if (!this.pendingMultiSelection || this.pendingMultiSelection?.length === 0) {
          const savedMultiSelection = this.globalSearchFiltersService.getMultiplePreviousHierarchyData();
          if (savedMultiSelection?.length > 0) {
            savedMultiSelection.forEach(item => {
              if (item.groupedIds?.length > 0) {
                const groupedItems = item.groupedIds.map((id: number) => ({
                  contextPointId: id,
                  contextPointName: item.contextPointName,
                }));
                this.pendingMultiSelection.push(...groupedItems);
              }
            });
          } else {
            this.pendingMultiSelection = savedMultiSelection || [this.tabValue.activeData];
          }
        }
        this.applyMultiSelectionState(selectionHierarchy);
        if (this.hierarchyData) {
          this.updateNextButtonVisibility();
        }
        this.cdr.markForCheck();
      }
    }
  }

  /**
   * @description Applies multi-selection state to hierarchy data items
   * Marks items as selected based on selection hierarchy and grouped IDs from activeData
   * 
   * @param {any[]} selectionHierarchy - The selection hierarchy array
   */
  private applyMultiSelectionState(selectionHierarchy: any[]): void {
    if (!this.tabValue.activeData) { return };
    if (this.tabValue.hierarchyValues && this.tabValue?.hierarchyValues?.length > 0) {
      const activeData = this.globalSearchFiltersService.getMultiplePreviousHierarchyData();
      const lastChip = activeData[0].groupedIds;
      const activeGroupIds = lastChip || [];
      this.pendingSelectionCriteria = {
        selectionHierarchy: selectionHierarchy,
        activeGroupIds: activeGroupIds
      };
      this.tabValue.hierarchyValues[this.currentIndex].defaultData = this.tabValue.hierarchyValues[this.currentIndex].defaultData.map(item => {
        const matchesGroupIds = activeGroupIds.includes(item.contextPointId);
        item.selected = matchesGroupIds;
        return item;
      });

    }
  }

  /**
   * @description Applies pending selection criteria to newly loaded data
   * Called whenever new data is loaded into hierarchy levels
   * 
   * @param {any[]} newData - The newly loaded data array
   */
  private applyPendingSelectionToNewData(newData: any[]): void {
    if (!this.pendingSelectionCriteria || !this.enableMulitpleSelection) return;

    this.markItemsAsSelected(
      newData,
      this.pendingSelectionCriteria.selectionHierarchy,
      this.pendingSelectionCriteria.activeGroupIds
    );
  }

  /**
   * @description Marks items as selected based on hierarchy and group criteria
   * 
   * @param {any[]} items - Items to check and mark as selected
   * @param {any[]} selectionHierarchy - Selection hierarchy array
   * @param {number[]} activeGroupIds - Active group IDs array
   */
  private markItemsAsSelected(items: any[], selectionHierarchy: any[], activeGroupIds: number[]): void {
    items.forEach(item => {
      // Check if item was selected based on selection hierarchy
      const wasSelectedInHierarchy = selectionHierarchy.some(selectedItem =>
        selectedItem.contextPointId === item.contextPointId
      );

      // Check if item matches activeData.groupedIds (for multi-selection groups)
      const matchesGroupIds = activeGroupIds?.length > 0 &&
        activeGroupIds.includes(item.contextPointId);

      // Item should be selected if it matches either condition
      item.selected = wasSelectedInHierarchy || matchesGroupIds;
    });
  }


  checkHierarchy(event: SearchResultModal | SearchHistoryResultsModal | ActiveData) {
    if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT') && this.tabValue.enableSelectionButtons) {
      this.selectedValue(event);
    } else {
      this.selectSearchedInput(event)
    }
  }

  /**
   * @description Handles the selection of a value from a dropdown or input event.
   * Determines the appropriate behavior based on hierarchy configuration and triggers necessary actions.
   * Now supports both single selection (object) and multi-selection (array) cases.
   *
   * @param {any | any[]} event - The event object containing the selected value(s) and associated data.
  */


  selectedValue(event: any | any[]): void {
    this.selectedResultInHierarchy.emit(event);
    if (Array.isArray(event)) {
      this.isMultiSelectionActivated = true;
      this.isUpdateSubGroupActivated = false;
      if (event.length === 0 && this.enableMulitpleSelection &&
        this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT')) {
        this.handleEmptyMultiSelection();
        return;
      } 
      this.handlePendingMultiSelection(event);
      return;
    }
    if (!this.tabValue?.name) return;
    switch (this.translate.instant(this.tabValue.name)) {
      case this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT'):
        this.handleCorporateAccount(event);
        break;

      case this.translate.instant('COMMON.GLOBAL_SEARCH.GEOGRAPHY_REGION'):
        this.handleGeoRegion(event);
        break;

      case this.translate.instant('COMMON.GLOBAL_SEARCH.SALES_REGION'):
        this.handleSalesRegion(event);
        break;
    }
  }

  /**
   * @description Handles pending multi-selection without immediate navigation.
   * Shows Next button if conditions are met.
   *
   * @param {any[]} selectedItems - Array of selected items
   */
  private handlePendingMultiSelection(selectedItems: any[]): void {
    if (!selectedItems || selectedItems?.length === 0) {
      this.showNextButton = false;
      return;
    }
    if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT') && this.tabValue.enableSelectionButtons) {
      this.pendingMultiSelection = selectedItems;
      this.disableMultiSelectButtons = false;
      this.checkIfCurrentLevelHasChildren(selectedItems);
      this.updateNextButtonVisibility();
    } else {
      this.selectedValue(selectedItems[0]);
    }
  }

  /**
   * @description Checks if any of the selected items have children.
   * 
   * @param {any[]} selectedItems - Array of selected items
   */
  private checkIfCurrentLevelHasChildren(selectedItems: any[]): void {
    this.currentLevelHasChildren = false;

    if (!this.hierarchyData || !selectedItems?.length) {
      return;
    }
    selectedItems.forEach(item => {
      const itemId = item.contextPointId || item[this.tabValue.uniqueKey];
      if (itemId) {
        const rawChildren = this.getRawChildrenByContextPointId(this.hierarchyData, itemId);
        if (rawChildren && rawChildren.length > 0) {
          const filteredChildren = this.bypassUnwantedContextPoints(rawChildren);
          if (filteredChildren?.length > 0) {
            this.currentLevelHasChildren = true;
          }
        }
      }
    });
  }

  /**
   * @description Gets raw children without processing (no concatPrimaryText).
   * Used for checking if children exist without modifying the data.
   * 
   * @param {ContextPointInfo[]} data - The hierarchy data
   * @param {number} contextPointId - The ID to find children for
   * @param {string} [preserveSecondaryText] - Optional secondary text to preserve in children
   * @returns {ContextPointInfo[] | null} Raw children or null
   */
  private getRawChildrenByContextPointId(data: ContextPointInfo[], contextPointId: number, preserveSecondaryText?: string): ContextPointInfo[] | null {
    const node = data.find(node => node.contextPointId === contextPointId);
    if (node) {
      const children = node.children ?? [];
      // If preserveSecondaryText is provided, add it to each child
      if (preserveSecondaryText && children?.length > 0) {
        return children.map(child => ({
          ...child,
          secondaryText: preserveSecondaryText
        }));
      }
      return children;
    }
    const childResults = data
      .filter(node => node.children?.length)
      .map(node => this.getRawChildrenByContextPointId(node.children, contextPointId, preserveSecondaryText))
      .find(result => result);
    return childResults || null;
  }

  /**
   * @description Updates the visibility of the Next button.
   * Shows Next button for multi-selection when there are children, and enables it only when items are selected.
   */
  private updateNextButtonVisibility(): void {
    if (this.enableMulitpleSelection) {
      this.showNextButton = true;
      const hasSelectedItems = this.pendingMultiSelection && this.pendingMultiSelection?.length > 0;
      this.nextButtonDisabled = !hasSelectedItems;
    } else {
      this.showNextButton = false;
      this.nextButtonDisabled = false;
    }
  }

  /**
   * @description Handles empty array selection in multi-selection mode.
   * Unchecks all items in current hierarchy level and updates pendingMultiSelection based on selected chips.
   */
  private handleEmptyMultiSelection(): void {
    this.showNextButton = false;
    if (this.tabValue.hierarchyValues && this.tabValue?.hierarchyValues?.[this.currentIndex]) {
      const currentLevel = this.tabValue.hierarchyValues[this.currentIndex];
      if (currentLevel.defaultData && currentLevel?.defaultData?.length > 0) {
        currentLevel.defaultData.forEach(item => {
          if (item.selected) {
            item.selected = false;
          }
        });
      }
    }
    this.pendingMultiSelection = [];
    if (this.selectedChips && this.selectedChips.length > 0) {
      const currentLevelChips = this.selectedChips.filter(chip =>
        chip.sequenceNumber === this.currentIndex
      );

      if (currentLevelChips?.length > 0) {
        currentLevelChips.forEach(chip => {
          const chipAsAny = chip;
          if (chipAsAny.isGrouped && chipAsAny.selectedItems) {
            this.pendingMultiSelection = this.pendingMultiSelection.concat(chipAsAny.selectedItems);
          } else {
            this.pendingMultiSelection.push({
              contextPointId: chip.contextPointId,
              contextPointName: chip.contextPointName,
            });
          }
        });
      }
    }
    this.disableMultiSelectButtons = true;
  }

  /**
   * @description Handles the Next button click for multi-selection.
   * Processes the pending selections and moves to next level.
   */
  public onNextButtonClick(): void {
    if (this.isUpdateSubGroupActivated) {
      this.pendingMultiSelection = this.tabValue.hierarchyValues?.[this.currentIndex]?.defaultData?.filter(item => item.selected) || [];
      this.addGroupedChip(this.pendingMultiSelection);
      this.currentIndex++;
      return;
    }else {
      if (this.pendingMultiSelection?.length > 0) {
        this.addGroupedChip(this.pendingMultiSelection);
        this.handleMultiSelection(this.pendingMultiSelection);
        this.showNextButton = false;
    }
    }
    
  }


  public onBackButtonClicked(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      const lastChip = this.selectedChips[this.selectedChips?.length - 1];
      let newPendingMultiSelection = [];
      if (lastChip && lastChip.groupedIds?.length > 0) {
        newPendingMultiSelection = lastChip.groupedIds.map((groupedId: number) => ({
          contextPointId: groupedId,
          contextPointName: lastChip.contextPointName
        }));
      }
      if (this.tabValue?.hierarchyValues?.[this.currentIndex]?.defaultData?.length > 0 && newPendingMultiSelection?.length > 0) {
        const pendingIds = newPendingMultiSelection.map(item => item.contextPointId);
        this.tabValue.hierarchyValues[this.currentIndex].defaultData.forEach(item => {
          item.selected = pendingIds.includes(item.contextPointId);
        });
      }
      this.pendingMultiSelection = this.tabValue.hierarchyValues?.[this.currentIndex]?.defaultData?.filter(item => item.selected) || [];
      this.selectedChips = this.selectedChips.slice(0, -1);
    }
  } 

  /**
   * @description Adds a grouped chip for multiple selections from the same level.
   * 
   * @param {any[]} selectedItems - Array of selected items from same level
   */
  private addGroupedChip(selectedItems: any[]): void {
    if (!selectedItems.length) return;

    const uniqueSelectedItems = selectedItems.filter((item, index, self) =>
      index === self.findIndex(listItem => listItem.contextPointId === item.contextPointId)
    );
    const currentHierarchy = this.tabValue.hierarchyValues?.[
      Math.min((this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.GEOGRAPHY_REGION') || this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.SALES_REGION')) ? this.currentIndex - 1 : this.currentIndex, this.tabValue?.hierarchyValues?.length - 1)
    ];
    const names = uniqueSelectedItems.map(item =>
      item.contextPointName ||
      (this.initiateManualSearch
        ? item[currentHierarchy?.contextPointIdKeys?.[1]]
        : item[this.tabValue?.contextPointIdKeys?.[1]])
    );
    const uniqueNames = [...new Set(names)];
    const groupedNames = uniqueNames.join(', ');
    const primaryId = uniqueSelectedItems[0].contextPointId ?? (
      this.initiateManualSearch
        ? uniqueSelectedItems[0][currentHierarchy?.uniqueKey ?? this.tabValue?.uniqueKey]
        : uniqueSelectedItems[0][this.tabValue?.uniqueKey]
    );
    
    const newGroupedIds = uniqueSelectedItems.map(item =>
      item.contextPointId ?? (
        this.initiateManualSearch
          ? item[currentHierarchy?.uniqueKey ?? this.tabValue?.uniqueKey]
          : item[this.tabValue?.uniqueKey]
      )
    );

    const existingChip = this.selectedChips.find(chip => 
      chip.isGrouped && 
      chip.groupedIds && 
      chip.groupedIds.length === newGroupedIds.length &&
      chip.groupedIds.every(id => newGroupedIds.includes(id)) &&
      newGroupedIds.every(id => chip.groupedIds.includes(id))
    );


    if (!existingChip) {
      const groupedChip = {
        contextPointId: primaryId,
        contextPointName: groupedNames,
        selectedSection: currentHierarchy?.name,
        sequenceNumber: this.selectedChips?.length === 0 ? 0 : this.selectedChips?.length,
        isGrouped: true,
        selectedItems: uniqueSelectedItems,
        groupedIds: newGroupedIds
      };
      
      this.selectedChips.push(groupedChip);
      
    }
  }

  /**
   * @description Handles multi-selection logic for selected items.
   * Only processes multi-selection for Corporate Account subgroups.
   *
   * @param {any[]} selectedItems - Array of selected items
   */
  private handleMultiSelection(selectedItems: any[]): void {
    if (!selectedItems || selectedItems?.length === 0) {
      return;
    }
    if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT') && this.tabValue.enableSelectionButtons) {
      this.selectedMultipleItems = selectedItems;
      this.handleCorporateAccountMultiSelect(selectedItems);
    } else {
      this.selectedValue(selectedItems[0]);
    }
  }

  /**
   * @description Handles multi-selection for Corporate Account subgroups.
   * Gets children from all selected items and displays them in next level.
   * 
   * @param {any[]} selectedItems - Array of all selected items
   */
  private handleCorporateAccountMultiSelect(selectedItems: any[]): void {
    if (this.initiateManualSearch) this.currentIndex++;

    if (!this.tabValue?.hierarchyValues?.length) {
      this.addHierarchyValue();
    }

    if (this.currentIndex === 0) {
      this.initiateAPIcalls(this.currentIndex);
      this.selectedMultipleItems = selectedItems;
    } else {
      this.selectedMultipleItems = selectedItems;
      this.selectedItem = selectedItems[0]; 
      this.filterId = selectedItems[0].contextPointId || selectedItems[0][this.tabValue.uniqueKey];
      this.renderDynamicLevelsForMultiSelection(selectedItems);
    }
  }

  /**
   * @description Handles empty cases for multi-selection scenarios.
   * 
   */
  private handleEmptyMultiSelectCases(): void {
    this.showErrorMessage = true;
    if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT') && this.currentIndex === 0) {
      this.tabValue.enableSelectionButtons = false;
      this.resultInfo = this.translate.instant('COMMON.GLOBAL_SEARCH.SUB_GROUPS.NO_SUBGROUPS_FOUND');
      this.cdr.markForCheck();
    } else {
      this.resultInfo = this.translate.instant('COMMON.GLOBAL_SEARCH.SUB_GROUPS.NO_FURTHER_SUBGROUPS_FOUND');
      this.cdr.markForCheck();
    }
    this.searchInput = this.tabValue.activeData?.contextPointName || '';
    this.tabValue.hierarchyValues[this.currentIndex].defaultData = [];
    this.isloading = false;
    this.cdr.markForCheck();
  }

 
/**
   * @description Gets combined children from multiple selected items.
   * 
   * @param {any[]} selectedItems - Array of selected items
   * @returns {any[]} Combined array of children from all selected items
   */
  private getCombinedChildrenFromMultipleItems(selectedItems: any[]): any[] {
    let allChildren = []; 

    selectedItems.forEach(item => {
      const itemIds = item.groupedIds || [item.contextPointId || item[this.tabValue.uniqueKey]];
      const parentContextPointName = item.contextPointName || item.name || '';
      const itemSecondaryText = item.secondaryText || '';

      itemIds.forEach((itemId: number) => {
        if (itemId && this.hierarchyData) {
          let preservedSecondaryText = '';
          if (itemSecondaryText) {
            preservedSecondaryText = `${itemSecondaryText} <img class="right-icon" src="../../../../../assets/images/global-search/right-icon.svg" alt="icon" /> ${parentContextPointName}`;
          } else {
            preservedSecondaryText = parentContextPointName;
          }

          const rawChildren = this.getRawChildrenByContextPointId(this.hierarchyData, itemId, preservedSecondaryText);
          if (rawChildren && rawChildren.length > 0) {
            allChildren = allChildren.concat(rawChildren);
          }
        }
      });
    });

    allChildren = allChildren.filter((item, index, self) =>
      index === self.findIndex(child => child.contextPointId === item.contextPointId)
    );

    return allChildren; // Return raw children for caller to process as needed
  }

  /**
   * @description Handles the logic when `tabValue.name` is 'Corporate Account'
   * @param {any} event - The event object containing the selected value
   */
  private handleCorporateAccount(event: any): void {
    if (this.initiateManualSearch) this.currentIndex++;

    if (!this.tabValue?.hierarchyValues?.length) {
      this.addHierarchyValue();
    }

    const hierarchyKey = event.contextPointId
      ? 'contextPointId'
      : this.initiateManualSearch
        ? this.tabValue.hierarchyValues[this.currentIndex]?.uniqueKey
        : this.tabValue.uniqueKey;

    this.filterId = event[hierarchyKey];
    this.selectedItem = event;
    if (this.currentIndex === 0) {
      this.initiateAPIcalls(this.currentIndex);
    } else {
      this.renderDynamicLevels(event);
    }

  }


  /**
   * Renders dynamic levels in the hierarchy based on multiple selected items.
   * Gets combined children from all selected items and sets up the next level.
   * 
   * @param selectedItems - Array of selected items to get children from
   */
  renderDynamicLevelsForMultiSelection(selectedItems: any[]): void {
    // Get combined children from all selected items (raw children without filtering)
    const allChildren = this.getCombinedChildrenFromMultipleItems(selectedItems);

    // Apply the same filtering logic as renderDynamicLevels for single selection
    const filteredChildren = this.stopFilteringIfReachedContextPointByid(allChildren, 5000);

    if (filteredChildren.length > 0) {
      // Don't call initiateChipList since chips are already added through addGroupedChip
      this.tabValue.hierarchyValues.push(this.globalSearchFiltersService.createHieraryValuesForCustomerDivision(this.tabValue?.hierarchyValues?.length + 1));
      this.initiateManualSearch = true;
      this.placeHolder = this.tabValue.hierarchyValues[this.currentIndex].placeholder;
      this.tabValue.hierarchyValues[this.currentIndex].defaultData = this.concatPrimaryText(filteredChildren, 'name');
    } else {
      // Don't call initiateChipList since chips are already added through addGroupedChip
      this.handleEmptyMultiSelectCases();
    }
  }

  /**
   * Renders dynamic levels in the hierarchy based on the provided context point event.
   * 
   * @param event - The context point event used to determine the dynamic levels to render.
   * 
   * This method performs the following actions:
   * - Checks if there are any children for the given context point ID within the hierarchy data.
   * - If children exist:
   *   - Initiates the chip list with the provided event.
   *   - Adds a new hierarchy value to the `tabValue.hierarchyValues` array.
   *   - Sets the `initiateManualSearch` flag to `true`.
   *   - Updates the placeholder text for the current index.
   *   - Sets the default data for the current hierarchy value based on the filtered children.
   * - If no children exist:
   *   - Calls the `selectSearchedInput` method with the provided event.
   */

  renderDynamicLevels(event: ContextPointInfo): void {
    if (this.stopFilteringIfReachedContextPointByid(this.getChildrenByContextPointId(this.hierarchyData, this.filterId), 5000).length > 0) {
      this.initiateChipList(event);
      this.tabValue.hierarchyValues.push(this.globalSearchFiltersService.createHieraryValuesForCustomerDivision(this.tabValue?.hierarchyValues?.length + 1))
      this.initiateManualSearch = true;
      this.placeHolder = this.tabValue.hierarchyValues[this.currentIndex].placeholder;
      this.tabValue.hierarchyValues[this.currentIndex].defaultData = this.stopFilteringIfReachedContextPointByid(this.getChildrenByContextPointId(this.hierarchyData, this.filterId), 5000);
    } else {
      this.initiateChipList(event);
      this.handleEmptyCases(event);
    }
  }

  /**
   * Stops filtering the provided `response` array if a context point with the specified `Id` is found.
   * If a context point with the matching `typeId` is found, an empty array is returned.
   * Otherwise, the original `response` array is returned.
   *
   * @param response - An array of `ContextPoint` objects to be checked.
   * @param Id - The `typeId` to search for in the `response` array.
   * @returns An empty array if a matching `typeId` is found; otherwise, the original `response` array.
   */
  stopFilteringIfReachedContextPointByid(response: ContextPointInfo[], Id: number): ContextPointInfo[] {
    return response.filter(({ typeId }) => typeId !== Id);
  }


  /**
   * @description Handles the logic when `tabValue.name` is 'Geo Region'
   * @param {any} event - The event object containing the selected value
   */



  private handleGeoRegion(event: any): void {
    this.currentIndex++;
    this.tabValue.enableSelectionButtons = this.currentIndex > 0;
    this.selectedItem = event;
    if (this.currentIndex <= this.tabValue?.hierarchyValues?.length - 1 && this.getChildrenBySubTypeId(this.tabValue.hierarchyValues[0].defaultData, event.contextPointId, 2).length > 0) {
      this.initiateChipList(event);
      this.initiateManualSearch = true;
      this.placeHolder = this.tabValue.hierarchyValues[this.currentIndex].placeholder;
      this.tabValue.hierarchyValues[this.currentIndex].defaultData =
        this.concatPrimaryText(this.getChildrenBySubTypeId(this.tabValue.hierarchyValues[0].defaultData, event.contextPointId, 2),
          'name');
    } else {
      this.selectedItem = event;
      this.initiateChipList(event);
      this.selectSearchedInput(event);
    }
  }
  /**
   * Recursively retrieves all children with a specific subTypeId from the given data array,
   * starting from the node with the specified contextPointId.
   *
   * @param data - The array of context points to search through.
   * @param contextPointId - The ID of the node to start the search from.
   * @param subTypeId - The subTypeId to filter the children by.
   * @returns An array of context points with the specified subTypeId.
   */
  getChildrenBySubTypeId(data: ContextPointInfo[], contextPointId: number, subTypeId: number): ContextPointInfo[] {
    const startNode = data.find(item => item.contextPointId === contextPointId);
    if (!startNode) return [];
    const filterNodes = (nodes: ContextPointInfo[]): ContextPointInfo[] =>
      nodes.flatMap(node =>
        node.subTypeId === subTypeId
          ? [node]
          : node.children?.length
            ? filterNodes(node.children)
            : []
      );

    return filterNodes([startNode]);
  }



  /**
   * @description Handles the logic when `tabValue.name` is 'Sales Region'
   * @param {any} event - The event object containing the selected value
   */
  private handleSalesRegion(event: any): void {
    this.currentIndex++;
    this.tabValue.enableSelectionButtons = this.currentIndex > 0;
    if (this.currentIndex <= this.tabValue?.hierarchyValues?.length - 1 && this.getChildrenByContextPointId(this.tabValue.hierarchyValues[0].defaultData, event.contextPointId).length > 0) {
      this.initiateChipList(event);
      this.initiateManualSearch = true;
      this.selectedItem = event;
      this.placeHolder = this.tabValue.hierarchyValues[this.currentIndex].placeholder;
      this.tabValue.hierarchyValues[this.currentIndex].defaultData =
        this.concatPrimaryText(
          this.getChildrenByContextPointId(this.tabValue.hierarchyValues[0].defaultData, event.contextPointId),
          'name'
        );
    } else {
      this.selectedItem = event;
      this.initiateChipList(event);
      this.selectSearchedInput(event);
    }
  }

  /**
   * @description Adds a new hierarchy value to the array with the appropriate index.
   */
  private addHierarchyValue(): void {
    this.tabValue?.hierarchyValues?.length === 0 ? this.tabValue.hierarchyValues.push(this.globalSearchFiltersService.createHieraryValuesForCustomerDivision(this.tabValue?.hierarchyValues?.length + 1)) : [];
  }


  /**
   * @description This function is used to select the searched result
   * @param event 
   */


  selectSearchedInput(event: SearchResultModal, index?: number, selectedChips?: chipInfo[]): void {
    this.selectedChips = selectedChips?.length > 0 ? selectedChips : this.selectedChips;
    this.isloading = true;
    event.selectionHierarchy = event.selectionHierarchy ? event.selectionHierarchy : this.selectedChips?.length > 0 ? this.selectedChips : null;
    const lastSelectedChip = this.selectedChips?.length > 0 ? this.selectedChips[this.selectedChips?.length - 1] : null;
    event.contextPointId = lastSelectedChip
      ? lastSelectedChip.contextPointId
      : event.contextPointId
        ? event.contextPointId
        : this.tabValue.enableHierarchy
          ? Number(event[this.tabValue.hierarchyValues[index].contextPointIdKeys[0]])
          : Number(event[this.tabValue.contextPointIdKeys[0]]),
    this.selectedResult.emit({ selectedSearchedResult: event, isResultSaved: false });
    this.globalSearchFiltersService.setHierarchyData(this.hierarchyData, this.selectedItem);
    this.searchInput = '';
    this.tabValue.searchResults = [];
    this.saveHistory = {
      serviceType: this.searchData.ServiceType,
      contextPointId: event.contextPointId,
      contextPointName: lastSelectedChip
        ? lastSelectedChip.contextPointName
        : event.contextPointName
          ? event.contextPointName
          : this.tabValue.enableHierarchy
            ? event[this.tabValue.hierarchyValues[index].contextPointIdKeys[1]]
            : event.primaryText,
      applicationType: this.searchData.ApplicationType,
      selectionHierarchy: event.selectionHierarchy
    };
    this.saveActiveData(this.saveHistory, event.primaryText);
    this.globalSearchFiltersService.saveUserContextSearchHistory(this.saveHistory).subscribe({
      next: () => {
        if (event.contextPointId) {
          event = {
            filterType: this.translate.instant(this.tabValue.name),
            SiteId: event.contextPointId,
            Site: event.contextPointName,
            CorporateAccountId: event.contextPointId,
            CorporateAccount: event.contextPointName,
            primaryText: event.contextPointName
          };
        }
        this.selectedResult.emit({ selectedSearchedResult: event, isResultSaved: true });
      },
      error: (error) => {
        if (error) {
          this.selectedResult.emit({ selectedSearchedResult: event, isResultSaved: false });
          this.isloading = false;
        }
      },
      complete: () => {
        this.getSearchHistory();
        this.cdr.markForCheck();
      }
    });
  }

  /**
   * Saves the active data from the provided search history item into the current tab value.
   *
   * @param item - The search history item containing context point information.
   * @returns The updated tab values with the active data and showActiveData flag set to true.
   *
   * @remarks
   * This method updates the `activeData` property of `tabValue` with the `contextPointId` and `contextPointName`
   * from the given `item`. It also sets `showActiveData` to `true` before returning the updated `tabValue`.
   *
   * @example
   * ```typescript
   * const updatedTab = saveActiveData({
   *   contextPointId: 123,
   *   contextPointName: 'Main Point'
   * });
   * ```
   */

  saveActiveData(item: SearchHistoryModal, text?: string): tabValues {
    this.tabValue.activeData = {
      contextPointId: item.contextPointId,
      contextPointName: text ? text : item.contextPointName,
      selectionHierarchy: item.selectionHierarchy ? this.globalSearchFiltersService.removeDuplicatesById(item.selectionHierarchy, 'contextPointId') : [],
      secondaryText: this.createSecondaryTextOnNames(item)
    }
    this.tabValue.showActiveData = this.tabValue.showActiveData ? this.tabValue.showActiveData : false;
    this.tabValue.isActive = true;
    return this.tabValue;
  }




  /**
  * @description This function is used clear the search results based on the search history results
  * @param arrObjts 
  * @param key 
  * @returns filtered and final checked SearchResultModal
  */


  removeDuplicates(arrObjts: SearchResultModal[], key: string): SearchResultModal[] {
    const result = arrObjts.filter(
      (propertyValues, index) => index === arrObjts.findIndex(
        other => propertyValues[key] === other[key]
      ));

    return result
  }

  /**
* @description This function is used clear the search results based on the search history results
* @param {obj :{ [key: string]: string }} 
* @returns { originalKey: string; transformedKey: string }[]
*/


  getObjectKeys(obj: { [key: string]: string }): { originalKey: string; transformedKey: string }[] {
    delete obj[this.tabValue.value];
    return Object.keys(obj)
      .filter(key => key !== 'SiteNameEnglish' && key !== 'FriendlyName')
      .map((key) => {
        const transformedKey = this.containsSlash(key) ? this.getLastSegment(key) : key;
        return { originalKey: key, transformedKey };
      });
  }



  /**
   * Generates secondary text for a given item based on the hierarchy values or matched fields.
   * 
   * @param {any} item - The item for which to generate the secondary text.
   * @param {number} [index] - The index of the hierarchy value to use for generating the text.
   * @returns {string} The generated secondary text.
   */

  generateSecondaryText(item: any, index?: number): string {
    if (this.tabValue?.hierarchyValues?.length > 0) {
      if (index > 0) {
        return index > 1
          ? `${item[this.tabValue.hierarchyValues[index - 2].value]} <img class="right-icon" src="../../../../../assets/images/global-search/right-icon.svg" alt="icon" /> ${item[this.tabValue.hierarchyValues[index - 1].value]}`
          : item[this.tabValue.hierarchyValues[index - 1].value];
      } else {
        return '';
      }
    } else {
      if (item.MatchedOnFields) {
        const keyPairs = this.getObjectKeys(item.MatchedOnFields);
        return keyPairs
          .map(
            (keyPair, idx) =>
              `${keyPair.transformedKey}: ${item.MatchedOnFields[keyPair.originalKey]?.toString() || 'N/A'}${idx < keyPairs?.length - 1 ? ', ' : ''}`
          )
          .join('');
      } else {
        return ""
      }

    }
  }

  /**
   * Prepares the secondary text for each search result item if the results exist and the tab value allows displaying secondary text.
   * 
   * @param {SearchResultModal[]} results - An array of search result items.
   * @returns {SearchResultModal[]} The modified array of search result items with secondary text generated, or the original array if conditions are not met.
   */
  prepareSecondaryText(results: SearchResultModal[], index?: number): SearchResultModal[] {
    if (results && this.tabValue.displaySecondaryText) {
      results = results.map((item) => {
        item.secondaryText = this.generateSecondaryText(item, index);
        return item;
      });
    } else {
      return results;
    }
  }

  /**
   * Generates a secondary text string based on the selection hierarchy of a given search history item.
   * Each context point name in the hierarchy is concatenated with a separator icon, except for the last element.
   *
   * @param {SearchHistoryModal | SearchResultModal} item - The search history item containing the selection hierarchy.
   * @returns {string} - A concatenated string of context point names with separators, or an empty string if the hierarchy is empty.
   */

  createSecondaryTextOnNames(item: SearchHistoryModal | SearchResultModal): string {
    if (item?.selectionHierarchy?.length > 0) {
      item = this.removeDuplicateName(item);
      const contextPointNames = item.selectionHierarchy.map((element, index) => {
        if (index < item?.selectionHierarchy?.length) {
          const isLastElement = index < item?.selectionHierarchy?.length - 1;
          const separator = isLastElement ? ' <img class="right-icon" src="../../../../../assets/images/global-search/right-icon.svg" alt="icon" /> ' : '';
          return element.contextPointName + separator;
        }
      });
      return contextPointNames.join(' ');
    }
    else {
      return '';
    }
  }

  /**
  * Removes duplicate entries from the `selectionHierarchy` of a given `SearchHistoryModal` object
  * by filtering out items that have the same `contextPointId` as the provided item's `contextPointId`.
  *
  * @param item - The `SearchHistoryModal` object to process and remove duplicates from.
  * @returns The updated `SearchHistoryModal` object with duplicates removed.
  */

  removeDuplicateName(item: SearchHistoryModal | SearchResultModal): SearchHistoryModal | SearchResultModal {
    item.selectionHierarchy = item.selectionHierarchy.filter(
      hierarchyItem => hierarchyItem.contextPointId !== item.contextPointId
    );
    return item
  }


  /**
    * @description This function checks if there is a special character (/) in the key
    * @param input
    * @returns {boolean}
    */
  containsSlash(input: string): boolean {
    return input.includes('/');
  }

  /**
  * @description This function gets the last key value after any special character
  * @param path
  * @returns {string}
  */
  getLastSegment(path: string): string {
    return path.split('/').pop() || '';
  }

  /**
   * Checks the current tab value and maps the accounts object accordingly.
   * 
   * If the current tab value's name is 'Sales Region', it will map the array of 
   * SearchResultModal objects to an array of their Accounts properties, flattening 
   * the result into a single array. Otherwise, it returns the original array.
   * 
   * @param array - The array of SearchResultModal objects to be processed.
   * @returns An array of SearchResultModal objects or an array of Accounts objects 
   *          if the tab value's name is 'Sales Region'.
   */
  checkAndMapAccountsObject(array: SearchResultModal[]): SearchResultModal[] {
    if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.SALES_REGION')) {
      const resultArray = array.map((result) => result.Accounts).flat();
      return resultArray
    } else {
      return array
    }
  }



  /**
* @description This function is used clear the search results based on the search history results
* @param results 
* @returns filtered and final checked SearchResultModal
*/


  concatPrimaryText(results: any[], objProp?: string, index?: number): any[] {
    const newArr = results.map(obj => {
      let displayText: string;

      if (objProp) {
        displayText = obj[objProp];
      } else if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.SITES')) {
        if (obj.FriendlyName) {
          displayText = obj.FriendlyName + this.concatForSites(obj);
        } else if (obj.SiteNameEnglish) {
          displayText = obj.SiteNameEnglish + this.concatForSites(obj);
        } else {
          displayText = obj[this.tabValue.value] + this.concatForSites(obj);
        }
      } else {
        displayText = obj[this.tabValue.value] + this.concatForSites(obj);
      }

      return {
        ...obj,
        primaryText: displayText,
        filterType: this.translate.instant(this.tabValue.name),
        contextPointName: displayText,
      };
    });
    this.prepareSecondaryText(newArr, index);
    return newArr;

  }

  /**
   * Concatenates and formats the location details for a site based on the provided search result object.
   * 
   * @param {SearchResultModal} obj - The search result object containing location details.
   * @returns {string} - A formatted string representing the site location and street, or an empty string if the tab value is not "Sites".
   * 
   * The function checks if the current tab is "Sites". If true, it constructs a location string based on the country, city, state/province, and street information from the search result object.
   * - For USA and CAD, it includes the city and state/province.
   * - For other countries, it includes the city and country.
   * 
   * The final display name includes the location and street information, formatted with hyphens.
   */

  concatForSites(obj: SearchResultModal): string {
    if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.SITES')) {
      let customerLocation = '';
      customerLocation = `${obj.City ? obj.City : ''}${obj.Country ? ', ' + obj.Country : obj.Country ? ', ' + obj.Country : ''}`;
      let siteDisplayName = "";
      if (customerLocation && obj.Street) {
        siteDisplayName += ` - ${customerLocation} - ${obj.Street}`;
      } else if (customerLocation) {
        siteDisplayName += ` - ${customerLocation}`;
      } else if (obj.Street) {
        siteDisplayName += ` - ${obj.Street}`;
      }
      return siteDisplayName;
    } else {
      return "";
    }
  }


  getCVOCHierarchy(): void {
    this.resultInfo = "";
    this.isloading = true;
    if (!this.filterId) return;
    this.subscriptions.push(
      this.globalSearchFiltersService.getCVOCHierarchy(this.filterId).subscribe({
        next: (response: any[]) => {
          this.searchInput = '';
          if (response?.length > 0) {
            this.hierarchyData = response;
            this.globalSearchFiltersService.setHierarchyData(this.hierarchyData);
            const children = this.getChildrenByContextPointId(this.hierarchyData, this.filterId);
            const filteredChildren = this.concatPrimaryText(this.bypassUnwantedContextPoints(children), 'name');
            if (filteredChildren?.length > 0) {
              this.tabValue.hierarchyValues[this.currentIndex].defaultData = filteredChildren;
              this.initiateChipList(this.selectedItem);
              this.initiateManualSearch = true;
              this.placeHolder = this.tabValue.hierarchyValues[this.currentIndex].placeholder;
              this.tabValue.hierarchyValues.push(
                this.globalSearchFiltersService.createHieraryValuesForCustomerDivision(this.tabValue?.hierarchyValues?.length + 1)
              );
            } else {
              this.handleEmptyCases();
            }
          } else {
            this.handleEmptyCases();
          }
          this.isloading = false;
          this.cdr.markForCheck();
        },
        error: () => {
          this.showErrorMessage = true;
          this.tabValue.hierarchyValues[this.currentIndex].defaultData = [];
          this.isloading = false;
          this.setInitialData();
          this.cdr.markForCheck();
        }
      })
    );
  }

  /**
   * @description Processes multi-selection hierarchy after API call.
   * Gets combined children from all selected items.
   * 
   * @param {any[]} selectedItems - Array of selected items
   */
  private processMultiSelectionHierarchy(selectedItems: any[]): void {
    const allChildren = this.getCombinedChildrenFromMultipleItems(selectedItems);

    if (allChildren?.length > 0) {
      // Note: Chips are already added through addGroupedChip when Next button was clicked

      // Filter and process the children
      const filteredChildren = this.stopFilteringIfReachedContextPointByid(allChildren, 5000);
      // Set up next level with processed children
      this.tabValue.hierarchyValues[this.currentIndex].defaultData = this.concatPrimaryText(filteredChildren, 'name');

      // Apply pending selection criteria to newly loaded data
      this.applyPendingSelectionToNewData(this.tabValue.hierarchyValues[this.currentIndex].defaultData);

      this.initiateManualSearch = true;
      this.placeHolder = this.tabValue.hierarchyValues[this.currentIndex].placeholder;
      this.tabValue.hierarchyValues.push(
        this.globalSearchFiltersService.createHieraryValuesForCustomerDivision(this.tabValue?.hierarchyValues?.length + 1)
      );

      // Clear the multi-selection items as they've been processed
      this.selectedMultipleItems = [];
    } else {
      this.handleEmptyMultiSelectCases();
    }
  }


  initialCVOCHierarchyData(response: any[]): void {

  }


  /**
   * Fetches the geographical regions and updates the component's state with the retrieved data.
   * 
   * This method retrieves the geography hierarchy data from the `globalSearchFiltersService` and processes it
   * to populate the `regionCountriesData` and `tabValue.defaultData` properties. It also handles loading states
   * and error scenarios.
   * 
   * - On success: Updates `regionCountriesData` with the hierarchy data and populates `tabValue.defaultData` 
   *   with concatenated primary text values.
   * - On error: Displays an error message and resets `tabValue.defaultData` to an empty array.
   * 
   * @remarks
   * The method uses RxJS subscriptions to handle asynchronous data fetching. It ensures proper state management
   * for loading and error handling.
   * 
   * @returns {void} This method does not return a value.
   */

  getGeoRegions(): void {
    if (!this.tabValue.hierarchyValues[this.currentIndex]?.defaultData || this.tabValue.hierarchyValues[this.currentIndex]?.defaultData?.length === 0) {
      this.resultInfo = "";
      this.isloading = true;
      this.subscriptions.push(
        this.globalSearchFiltersService.getGeographyHierarchy().subscribe({
          next: (response: ContextPointInfo[]) => {
            this.regionCountriesData = response?.length > 0 && response[0]?.children?.[0]?.children
              ? response[0].children[0].children
              : [];
            if (this.regionCountriesData?.length > 0) {
              this.tabValue.hierarchyValues[this.currentIndex].defaultData = this.concatPrimaryText(this.regionCountriesData, 'name');
            } else {
              this.handleEmptyCases();
            }
            this.isloading = false;
          },
          error: () => {
            this.showErrorMessage = true;
            this.tabValue.defaultData = [];
            this.isloading = false;
          }, complete: () => {
            this.cdr.markForCheck();
          }
        })
      );
    }
  }


  /**
   * Retrieves the EVOCHierarchy data and updates the component's state accordingly.
   * 
   * This method checks if there is existing default data for the current hierarchy tab.
   * If data exists, it makes an API call to fetch the hierarchy data. The response is processed
   * to extract and format the relevant information. If no data is returned or an error occurs,
   * appropriate error handling is performed.
   * 
   * @remarks
   * - Updates `resultInfo`, `isloading`, `showErrorMessage`, and `tabValue.hierarchyValues` based on the API response.
   * - Subscribes to the `getEVOCHierarchy` service method and handles both success and error cases.
   * 
   * @privateRemarks
   * - The `handleEmptyCases` function is used to handle scenarios where no data is returned.
   * - The `concatPrimaryText` method is used to format the response data.
   * 
   * @throws
   * - Handles errors by setting `showErrorMessage` to `true` and clearing the default data.
   * 
   * @returns void
   */

  getEVOCHierarchy(): void {
    if (!this.tabValue.hierarchyValues[this.currentIndex]?.defaultData || this.tabValue.hierarchyValues[this.currentIndex]?.defaultData?.length === 0) {
      this.resultInfo = "";
      this.isloading = true;
      this.subscriptions.push(
        this.globalSearchFiltersService.getEVOCHierarchy().subscribe({
          next: (response: ContextPointInfo[]) => {
            this.salesRegionDistrictsTerritoriesData = response?.length > 0 && response[0]?.children?.[0]?.children
              ? response[0].children[0].children
              : [];
            const responseData = this.filterBySubTypeId(this.salesRegionDistrictsTerritoriesData.flatMap(region => region.children || []), [4, 5, 6]);
            if (responseData?.length > 0) {
              this.tabValue.hierarchyValues[this.currentIndex].defaultData = this.concatPrimaryText(responseData, 'name');
            } else {
              this.handleEmptyCases();
            }
            this.isloading = false;
          },
          error: () => {
            this.showErrorMessage = true;
            this.tabValue.hierarchyValues[this.currentIndex].defaultData = [];
            this.isloading = false;
          }, complete: () => {
            this.cdr.markForCheck(); 
          }
        })
      );
    }
  }


  /**
   * Filters an array of `ContextPointInfo` objects by their `subTypeId` property.
   * If the `subTypeId` of an object matches any of the provided `subTypeIds`, 
   * the object is included in the result. The function also recursively filters 
   * the `children` property of each object.
   *
   * @param data - The array of `ContextPointInfo` objects to filter.
   * @param subTypeIds - A single `subTypeId` or an array of `subTypeIds` to filter by.
   * @returns A new array of `ContextPointInfo` objects that match the specified `subTypeIds`.
   */
  filterBySubTypeId(data: ContextPointInfo[], subTypeIds: number | number[]): ContextPointInfo[] {
    if (data?.length > 0) {
      const subTypeIdArray = Array.isArray(subTypeIds) ? subTypeIds : [subTypeIds];
      return data.filter(item => subTypeIdArray.includes(item.subTypeId)).map(item => {
        return {
          ...item,
          children: this.filterBySubTypeId(item.children || [], subTypeIdArray)
        };
      });
    } else {
      return [];
    }
  }
  /**
   * Handles scenarios where no valid data is available or an empty case is encountered.
   * 
   * - Displays an error message to inform the user.
   * - Selects the currently searched input item.
   * - Clears the default data for the current hierarchy value.
   * - Stops the loading indicator.
   */

  handleEmptyCases($event?: ContextPointInfo | SearchResultModal): void {
    this.showErrorMessage = true;
    if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT') && this.currentIndex === 0) {
      this.tabValue.enableSelectionButtons = false;
      this.resultInfo = this.translate.instant('COMMON.GLOBAL_SEARCH.SUB_GROUPS.NO_SUBGROUPS_FOUND');
      this.cdr.markForCheck();
    } else {
      this.selectSearchedInput($event ? $event : this.selectedItem);
    }
    this.searchInput = this.tabValue.activeData.contextPointName;
    this.tabValue.hierarchyValues[this.currentIndex].defaultData = [];
    this.isloading = false;
    this.cdr.markForCheck();
  };


  /**
 * Recursively finds the node with the given contextPointId and returns its children.
 * @param {ContextPointInfo[]} data - The JSON data array.
 * @param {number} contextPointId - The ID of the node to find.
 * @returns {Array|null} - The children of the node, or null if not found.
 */
  getChildrenByContextPointId(data: ContextPointInfo[], contextPointId: number) {
    const node = data.find(node => node.contextPointId === contextPointId);
    if (node) {
      return this.concatPrimaryText(node.children ?? [], 'name');
    }
    const childResults = data
      .filter(node => node.children?.length)
      .map(node => this.getChildrenByContextPointId(node.children, contextPointId))
      .find(result => result);
    return childResults ? this.concatPrimaryText(childResults, 'name') : null;
  }


  /**
   * Filters and processes an array of `ContextPoint` objects to bypass unwanted context points.
   * 
   * This method filters the input `response` array to include only those context points
   * where `typeId` equals `4000` and `subTypeId` equals `3`. It then extracts and flattens
   * the `children` property of the filtered context points, returning a new array of these children.
   * 
   * @param response - An array of `ContextPoint` objects to be filtered and processed.
   * @returns A flattened array of `ContextPoint` objects derived from the `children` property
   *          of the filtered context points. If a context point has no `children`, it is ignored.
   */

  bypassUnwantedContextPoints(response: ContextPointInfo[]): ContextPointInfo[] {
    return response
      .filter(({ typeId, subTypeId }) => typeId === 4000 && subTypeId === 3)
      .flatMap(({ children }) => children || []);
  }

  /**
   * Retrieves the user context access data and processes it for display.
   * 
   * This method fetches user context access information based on the current tab's context point type ID.
   * It processes the response to include primary text concatenation and site name mapping. The data is
   * then filtered into default and favorite datasets based on user preferences. In case of an error, 
   * it handles the error state and resets the data.
   * 
   * @returns {void}
   * 
   */
  getUserContextAccess(): void {
    this.isloading = true;
    this.subscriptions.push(
      this.globalSearchFiltersService.getUserContextAccess(this.tabValue.contextPointTypeId, 1).subscribe({
        next: (response: any) => {
          response = this.concatPrimaryText(response, 'name').map(item => ({ ...item, Site: item.name }));
          this.tabValue.defaultData = this.tabValue.showDefaultData ? this.filterFavourites(response, false) : [];
          this.tabValue.favouritesData = this.tabValue.showFavouriteData ? this.filterFavourites(response, true) : [];
          this.isloading = false;
        },
        error: () => {
          this.showErrorMessage = true;
          this.tabValue.defaultData = [];
          this.tabValue.favouritesData = [];
          this.isloading = false;
        }, 
        complete: () => {
          this.cdr.markForCheck();
        }
      })
    );
  }


  /**
   * Filters a list of items based on their "isFavorite" property.
   *
   * @param data - An array of items to be filtered.
   * @param showFavourites - A boolean indicating whether to show only favorite items.
   *                          If `true`, the function returns items where `isFavorite` is `true`.
   *                          If `false`, the function returns items where `isFavorite` is `false`.
   * @returns A filtered array of items based on the "isFavorite" property.
   */
  filterFavourites(data: ContextPointInfo[], showFavourites: boolean): ContextPointInfo[] {
    const filteredData = showFavourites
      ? data.filter(item => item.isFavorite)
      : data.filter(item => !item.isFavorite);

    return filteredData
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
      .slice(0, 10)
      .map(element => ({
        ...element,
        filterType: this.translate.instant(this.tabValue.name),
        [this.tabValue.contextPointIdKeys[0]]: element.contextPointId,
        [this.tabValue.contextPointIdKeys[1]]: element.name,
      }));
  }


  filterResults(data: any[], filterKey: string): any[] {
    if (!this.searchInput.trim()) {
      return data;
    }
    const lowerCaseSearchInput = this.searchInput.toLowerCase();
    const filteredData = data?.length > 0 ? data.filter(item =>
      item.primaryText ? item.primaryText.toLowerCase().includes(lowerCaseSearchInput) : ""
    ) : [];
    if (filteredData?.length > 0) {
      return filteredData
    } else {
      return []
    }
  }



  getFilteredResults(): any[] {
    const data = !this.initiateManualSearch && this.tabValue?.defaultData?.length > 0
      ? this.currentHierarchy?.defaultData
      : this.tabValue?.defaultData;
    return this.filterResults(this.currentHierarchy?.defaultData, 'ContextPointName');
  }

  /**
 * @description Removes a chip from the selectedChips array based on the provided index.
 * Adjusts the currentIndex accordingly.
 * 
 * @param {number} index - The index of the chip to be removed.
 * @throws {Error} Throws an error if the provided index is invalid.
 */

  removeChipAtIndex(index: number): void {
    this.resultInfo = "";
    this.searchInput = "";

    if (index < 0 || index >= (this.selectedChips?.length ?? 0)) {
      throw new Error(`Invalid index: ${index}. Index must be between 0 and ${this.selectedChips?.length - 1}.`);
    }
    if (index === 0) {
      this.setInitialData();
      return;
    }

    if (this.enableMulitpleSelection && this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT')) {
      const chipsToRemove = this.selectedChips.slice(index);
      chipsToRemove.forEach(chip => {
        const chipInfo = this.globalSearchFiltersService.getMultiSelectionChipProperties(chip);
        if (chipInfo.groupedIds && chipInfo.groupedIds.length > 0) {
          this.pendingMultiSelection = this.pendingMultiSelection.filter(item =>
            !chipInfo.groupedIds.includes(item.contextPointId)
          );
        } else {
          this.pendingMultiSelection = this.pendingMultiSelection.filter(item =>
            item.contextPointId !== chip.contextPointId
          );
        }
      });
      if (this.tabValue.hierarchyValues && this.tabValue.hierarchyValues.length > 0) {
        for (let levelIndex = 0; levelIndex < this.tabValue.hierarchyValues.length; levelIndex++) {
          const hierarchyLevel = this.tabValue.hierarchyValues[levelIndex];
          if (hierarchyLevel.defaultData && hierarchyLevel.defaultData.length > 0) {
            hierarchyLevel.defaultData.forEach(item => {
              let shouldUncheck = false;
              if (levelIndex >= index) {
                shouldUncheck = item.selected === true;
              } else {
                chipsToRemove.forEach(chip => {
                  const chipInfo = this.globalSearchFiltersService.getMultiSelectionChipProperties(chip);
                  if (chipInfo.groupedIds && chipInfo.groupedIds.length > 0) {
                    shouldUncheck = shouldUncheck || chipInfo.groupedIds.includes(item.contextPointId);
                  } else {
                    shouldUncheck = shouldUncheck || chip.contextPointId === item.contextPointId;
                  }
                });
              }
              if (shouldUncheck) {
                item.selected = false;
              }
            });
          }
        }
      }
      this.pendingMultiSelection = [];
      this.updateNextButtonVisibility();
    }

    this.selectedChips = this.selectedChips.slice(0, index);

    const previousChip = this.selectedChips[index - 1];
    this.selectedItem = {
      contextPointId: previousChip.contextPointId,
      contextPointName: previousChip.contextPointName,
      primaryText: previousChip.contextPointName,
      filterType: this.translate.instant(this.tabValue.name),
      name: previousChip.contextPointName,
      typeId: this.tabValue.contextPointTypeId
    };

    this.filterId = previousChip.contextPointId;
    if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT')) {

      this.tabValue.hierarchyValues = this.tabValue.hierarchyValues.slice(0, index + 1);
      for (let i = index; i < this.tabValue.hierarchyValues.length; i++) {
        if (this.tabValue.hierarchyValues[i]) {
          this.tabValue.hierarchyValues[i].defaultData = [];
        }
      }
    const remainingSelectionHierarchy = this.selectedChips.slice(0, -1);
    const remainingDataItem = {
      contextPointId: previousChip.contextPointId,
      contextPointName: previousChip.contextPointName,
      selectionHierarchy: remainingSelectionHierarchy,
      groupedIds: previousChip.groupedIds || [],
    };
    if (this.enableMulitpleSelection) {
      this.globalSearchFiltersService.setMultipleHierarchyData(this.concatPrimaryText([remainingDataItem], 'contextPointName'))
    }
      this.currentIndex = index - 1;
      this.placeHolder = this.tabValue.hierarchyValues[this.currentIndex]?.placeholder || this.tabValue.placeholder;
      if (this.hierarchyData && this.tabValue.hierarchyValues[index]) {
        const children = this.getChildrenByContextPointId(this.hierarchyData, this.filterId);
        if (children && children.length > 0) {
          const filteredChildren = this.concatPrimaryText(this.bypassUnwantedContextPoints(children), 'name');
          if (filteredChildren && filteredChildren.length > 0) {
            this.tabValue.hierarchyValues[index].defaultData = this.stopFilteringIfReachedContextPointByid(filteredChildren, 5000);
            if (this.enableMulitpleSelection) {
              this.tabValue.hierarchyValues[index].defaultData.forEach((item: any) => {
                if (item.selected) {
                  item.selected = false;
                }
              });
            }
          }
        }
      }

    } else if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.SALES_REGION')) {
      this.currentIndex = this.currentIndex - 1;
    } else {
      this.currentIndex = index - 1;
    }
    this.initiateManualSearch = this.selectedChips?.length > 0;
  }



  /**
   * Sets the selected item based on the provided index.
   * If index is 0, uses the current selectedItem; otherwise, uses the chip at the given index.
   * Updates selectedItem to the children of the selected context point.
   *
   * @param {number} index - The index of the chip to select.
   */

  setSelectedItem(index: number): void {
    if (index >= 0) {
      const indexItem = index === 0 ? this.selectedItem : this.selectedChips[index];
      const indexValue = index
      this.selectedItem = this.tabValue.hierarchyValues[indexValue].defaultData.find(item => item.contextPointId === indexItem.contextPointId) || indexItem;
    }
  }





  clearActiveSelection() {
    this.tabValue.activeData = null; // Clear the active data
    this.selectedResult.emit({ selectedSearchedResult: null, isResultSaved: true, isClearSelection: true }); // Emit an event to notify that no result is selected
    this.setInitialData();
  }


  /**
   * @description Resets the search component to its initial state.
   * This method clears the selected chips, resets the search input, and reinitializes
   * the placeholder and index values to their default state.
   *
   * @returns {void}
   */

  setInitialData(): void {
    this.initiateManualSearch = false; // Disable manual search mode
    this.selectedChips = []; // Clear all selected chips
    this.selectedMultipleItems = []; // Clear multiple selected items
    this.pendingMultiSelection = []; // Clear pending selections
    this.showNextButton = false; // Hide Next button
    this.nextButtonDisabled = false; // Reset Next button disabled state
    this.currentLevelHasChildren = false; // Reset children check
    this.pendingSelectionCriteria = null; // Clear pending selection criteria
    this.resultInfo = "";
    this.searchInput = this.selectedSubGroupAccount ? "" : this.searchInput;
    this.tabValue.enableSelectionButtons = false;
    this.selectedSubGroupAccount = "" // Reset result information
    this.currentIndex = 0; // Reset the current index to the initial state
    this.placeHolder = this.tabValue?.placeholder || ''; // Set the placeholder to the default value

    if (this.tabValue.hierarchyValues && this.tabValue.hierarchyValues.length > 0) {
      this.tabValue.hierarchyValues.forEach(hierarchyLevel => {
        if (hierarchyLevel.defaultData && hierarchyLevel.defaultData.length > 0) {
          hierarchyLevel.defaultData.forEach(item => {
            item.selected = false;
          });
        }
      });
    }
  }

  /**
   * @description Adds a chip to the selectedChips array.
   * Dynamically determines the context and updates the chip data structure.
   * Note: For multi-selection, chips are added through addGroupedChip method when Next button is clicked.
   * 
   * @param {object} item - The item data used to create a new chip.
   */


  initiateChipList(item) {

    const currentHierarchy = this.tabValue.hierarchyValues?.[
      Math.min((this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.GEOGRAPHY_REGION') || this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.SALES_REGION')) ? this.currentIndex - 1 : this.currentIndex, this.tabValue?.hierarchyValues?.length - 1)
    ];
    if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT')) {
      this.selectedChips.push({
        contextPointId: item.contextPointId ?? (
          this.initiateManualSearch
            ? item[currentHierarchy?.uniqueKey ?? this.tabValue?.uniqueKey]
            : item[this.tabValue?.uniqueKey]
        ),
        contextPointName: item.contextPointName ?? (
          this.initiateManualSearch
            ? item[currentHierarchy?.contextPointIdKeys?.[1]]
            : item[this.tabValue?.contextPointIdKeys?.[1]]
        ),
        selectedSection: currentHierarchy?.name,
        groupedIds :item.groupedIds ? item.groupedIds : [],
        sequenceNumber: this.selectedChips?.length === 0 ? 0 : this.selectedChips?.length
      });
    } else if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.GEOGRAPHY_REGION') || this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.SALES_REGION')) {
      this.selectedChips.push({
        contextPointId: item.contextPointId,
        contextPointName: item.contextPointName,
        selectedSection: currentHierarchy?.name,
        sequenceNumber: this.selectedChips?.length === 0 ? 0 : this.selectedChips?.length
      });
    }


  }

  get currentHierarchy() {
    return this.tabValue?.hierarchyValues?.[
      Math.min(this.currentIndex, this.tabValue?.hierarchyValues?.length - 1)
    ];
  }


  /**
   * @description Initiates API calls based on the provided hierarchy key and updates relevant UI properties.
   *
   * @param {string} key - The hierarchy key to determine which API to call.
   */

  initiateAPIcalls(key: number): void {
    if (key === 0) {
      this.getCVOCHierarchy();
    } else {
      this.getChildrenByContextPointId(this.hierarchyData, this.filterId)
    }
  }


  /*
   * Maps the provided search history results data with filter names based on the current tab value.
   * If the tab value name is 'Geo Region' or 'Sales Region', it maps the `contextPointSubTypeId` 
   * to the corresponding filter name from the respective naming array.
   * 
   * @param {SearchHistoryResultsModal[]} data - The search history results data to be mapped.
   * @returns {SearchHistoryResultsModal[]} - The mapped search history results data with filter names.
   */

  mapWithFilterNaming(data: SearchHistoryResultsModal[]): SearchHistoryResultsModal[] {
    if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.GEOGRAPHY_REGION') || this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.SALES_REGION')) {
      const namingArray = this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.GEOGRAPHY_REGION') ? regionsContextPointSubTypeId : SalesRegionsContextPointSubTypeId
      const mappedArray = data.map((value) => {
        namingArray.forEach((element) => {
          if (value.contextPointSubTypeId === element.id) {
            value.filterName = element.name;
          }
        });
        return value;
      });
      return mappedArray;
    } else {
      return data
    }
  }

  /**
   * Constructs a translated heading string by combining the translation
   * for a common global search prefix with the translation of the current tab's name.
   *
   * @returns {string} The translated heading string.
   */
  getTranslatedHeading(): string {
    return `${this.translate.instant('COMMON.GLOBAL_SEARCH.MY')} ${this.translate.instant(this.tabValue?.name)}`;
  }


  /**
   * Creates a hierarchy based on the provided search result and index.
   * If the index is greater than 0, it constructs a list of hierarchy values
   * by slicing and mapping the `hierarchyValues` array, then calls `selectSearchedInput`
   * with the generated values. Otherwise, it calls `selectSearchedInput` without additional values.
   *
   * @param event - The search result object containing data for hierarchy creation.
   * @param index - The index indicating the level of the hierarchy to be created.
   *                If greater than 0, hierarchy values are processed; otherwise, only the event and index are used.
   */
  createHierarchy(event: SearchResultModal, index: number): void {
    if (index > 0) {
      const hierarchyItems = this.tabValue.hierarchyValues
        .slice(0, index + 1)
        .map((hierarchyValue, i) => ({
          contextPointId: event[hierarchyValue.contextPointIdKeys[0]],
          contextPointName: event[hierarchyValue.contextPointIdKeys[1]],
          sequenceNumber: i,
        }));
      this.selectSearchedInput(event, index, hierarchyItems);
    } else {
      this.selectSearchedInput(event, index);
    }
  }


  /**
   * Handles the selection logic when a user selects an item from the search bar results.
   * Now supports both single and multi-selection scenarios.
   * 
   * - If the current tab is "Corporate Account", it initializes the chip list with the selected item
   *   and then selects the searched input.
   * - For all other tabs, it only selects the searched input.
   * - Supports multi-selection when selectedMultipleItems array has items.
   *
   * @remarks
   * This method relies on translation keys to determine the current tab context.
   *
   * @internal
   */
  triggerSelection(): void {
    const isCorporateAccount =
      this.translate.instant(this.tabValue.name) ===
      this.translate.instant('COMMON.GLOBAL_SEARCH.CORPORATE_ACCOUNT');
    if (this.enableMulitpleSelection && isCorporateAccount) {
      this.addGroupedChip(this.pendingMultiSelection);
      if (this.selectedChips && this.selectedChips.length > 0) {
        const lastChip = this.selectedChips[this.selectedChips?.length - 1];
        const selectionHierarchy = this.selectedChips.slice(0, -1);
        const activeDataItem = this.isMultiSelectionActivated ? {
          contextPointId: lastChip.contextPointId,
          contextPointName: lastChip.contextPointName,
          selectionHierarchy: selectionHierarchy,
          groupedIds: lastChip.groupedIds || [],
        } : {
          contextPointId: this.globalSearchFiltersService.getMultiplePreviousHierarchyData()[0]?.contextPointId,
          contextPointName: this.globalSearchFiltersService.getMultiplePreviousHierarchyData()[0]?.contextPointName,
          selectionHierarchy: this.globalSearchFiltersService.getMultiplePreviousHierarchyData()[0]?.selectionHierarchy || [],
          groupedIds: this.globalSearchFiltersService.getMultiplePreviousHierarchyData()[0]?.groupedIds || [],
        };
        this.globalSearchFiltersService.setMultipleHierarchyData(this.concatPrimaryText([activeDataItem], 'contextPointName'));
        this.multipleSelectedResult.emit(this.concatPrimaryText([activeDataItem], 'contextPointName'));
        this.saveActiveData(activeDataItem);
      }
      return;
    }
    if (this.selectedItem) {
      if (isCorporateAccount) {
        this.initiateChipList(this.selectedItem);
      }
      this.selectSearchedInput(this.selectedItem);
    }
  }


  getSelectedInfo($event: SearchHistoryModal | userContextAcessInfo): void {
    this.selectedInfo = $event;
    this.isloading = true;
    this.cdr.markForCheck();
    let searchInFields = this.tabValue.contextPointIdKeys;
    if ($event.filterName && this.tabValue?.hierarchyValues?.length > 0) {
      const matchingHierarchy = this.tabValue.hierarchyValues.find(hierarchy =>
        hierarchy.value === $event.filterName ||
        this.globalSearchFiltersService.getFilterNameMapping($event.filterName) === hierarchy.value
      );
      if (matchingHierarchy?.contextPointIdKeys) {
        searchInFields = matchingHierarchy.contextPointIdKeys;
      }
    }
    const searchResultBody: SearchRequesModel = {
      searchText: '',
      count: 1,
      searchInFields: searchInFields,
      responseFields: this.tabValue.responseFileds,
      filterCondition: 'or',
      filterBy: {
        [searchInFields[0]]: $event.contextPointId.toString(),
      },
    }

     if (this.translate.instant(this.tabValue.name) === this.translate.instant('COMMON.GLOBAL_SEARCH.SALES_REGION')) {
      searchResultBody.searchInFields = ['Accounts{SalesRegion,SalesRegionId,District,DistrictId,Territory,TerritoryId}']
      searchResultBody.filterBy = {
        [`Accounts{${searchInFields[0]}}`]: $event.contextPointId.toString()
      }
    }

    this.getContextSearchResult(searchResultBody);
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.globalSearchFiltersService.clearCancelToken(this.instanceId);
  }

}
